module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/domofon-1-abcf2a4e1fc1bd3f49638eb095bac2ec.webp";